import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy, HorizontalRule } from '@elparking/components'

import HighlightedBlock from 'commons/js/ui/HighlightedBlock'
import { FormattedMessage } from 'react-intl'
import { VIAT_DISCOUNT_TYPE_REGISTRATION_NEEDED } from 'commons/js/constants'

const Discount = ({ type }) => <HighlightedBlock background='transparent' display='inline-block' color='main' padding='0.3em' width='auto' borderRadius='3px'>
    <Copy fontSize='xxSmall' fontWeight='book' transform='uppercase' color='main' textAlign='center' padding='0'>
        { type === VIAT_DISCOUNT_TYPE_REGISTRATION_NEEDED
            ? <FormattedMessage defaultMessage='Descuento con registro' />
            : <FormattedMessage defaultMessage='Descuento automático' />
        }
    </Copy>
</HighlightedBlock>

Discount.propTypes = {
    type: PropTypes.number.isRequired,
}

const ListItem = ({ highway }) => {
    return (
        <Box>
            <Box mb='5px' display={['block', 'none']}>
                <Discount type={highway.type} />
            </Box>
            <Flex mb='0.5em' justifyContent='space-between' alignItems='center'>
                <Box p='0.3em 0 0 0' w={['100%', 'auto']}>
                    <Copy padding='0' fontSize='large' fontWeight='book' color='gray'>{ highway.name }</Copy>
                </Box>
                <Box textAlign='right' display={['none', 'block']}>
                    <Box ml='5px'>
                        <Discount type={highway.type} />
                    </Box>
                </Box>
            </Flex>
            <Copy padding='0' fontSize={['small', 'medium']} fontWeight='regular' color='gray60'>{ highway.description }</Copy>
            <Box mt='1em'>
                <a rel='noopener noreferrer' href={highway.url} target='_blank'>
                    <Box mr='0.3em'>
                        <Copy transform='uppercase' padding='0' color='main' size='xxSmall' fontWeight='book'>
                            <FormattedMessage defaultMessage='Ver más información' />
                        </Copy>
                    </Box>
                </a>
            </Box>
            <HorizontalRule />
        </Box>
    )
}

ListItem.propTypes = {
    highway: PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        type: PropTypes.number.isRequired,
    }).isRequired,
}

export default ListItem
